import { Component, computed, EventEmitter, Output, signal } from '@angular/core';
import { UserState } from '../../../shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "../services/notifications-v2.service";
import * as i2 from "@ngxs/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../basic-features/icon-v2/icon.component";
import * as i5 from "../../../basic-features/button-group-v2/button-group.component";
import * as i6 from "../../../basic-features/button-v2/button.component";
import * as i7 from "./notification-card-v2/notification-card-v2.component";
import * as i8 from "@ngx-translate/core";
function NotificationsSidebarV2Component_ng_container_16_Conditional_1_geaui_notification_card_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-notification-card-v2", 15);
    i0.ɵɵlistener("markedAsRead", function NotificationsSidebarV2Component_ng_container_16_Conditional_1_geaui_notification_card_v2_0_Template_geaui_notification_card_v2_markedAsRead_0_listener() {
      const notification_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.readNotification(notification_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("notification", notification_r2)("userTimezoneOffset", ctx_r2.userTimezoneOffset);
  }
}
function NotificationsSidebarV2Component_ng_container_16_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NotificationsSidebarV2Component_ng_container_16_Conditional_1_geaui_notification_card_v2_0_Template, 1, 2, "geaui-notification-card-v2", 14);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.unReadNotifications());
  }
}
function NotificationsSidebarV2Component_ng_container_16_Conditional_2_geaui_notification_card_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-notification-card-v2", 15);
    i0.ɵɵlistener("markedAsRead", function NotificationsSidebarV2Component_ng_container_16_Conditional_2_geaui_notification_card_v2_0_Template_geaui_notification_card_v2_markedAsRead_0_listener() {
      const notification_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.readNotification(notification_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const notification_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("notification", notification_r5)("userTimezoneOffset", ctx_r2.userTimezoneOffset);
  }
}
function NotificationsSidebarV2Component_ng_container_16_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NotificationsSidebarV2Component_ng_container_16_Conditional_2_geaui_notification_card_v2_0_Template, 1, 2, "geaui-notification-card-v2", 14);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.notifications());
  }
}
function NotificationsSidebarV2Component_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationsSidebarV2Component_ng_container_16_Conditional_1_Template, 1, 1, "geaui-notification-card-v2", 13)(2, NotificationsSidebarV2Component_ng_container_16_Conditional_2_Template, 1, 1, "geaui-notification-card-v2", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showNewNotifications ? 1 : 2);
  }
}
function NotificationsSidebarV2Component_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵelement(2, "geaui-icon-v2", 17);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 19);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("file", "48px_bell-none");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "NOTIFICATIONS-SIDEBAR.NO-NOTIFICATIONS-TITLE"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "NOTIFICATIONS-SIDEBAR.NO-NOTIFICATIONS-INFO"));
  }
}
function NotificationsSidebarV2Component_div_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "header")(2, "div", 1)(3, "span", 2);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 3);
    i0.ɵɵlistener("click", function NotificationsSidebarV2Component_div_18_Template_div_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeNotificationDetails());
    });
    i0.ɵɵelement(7, "geaui-icon-v2", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(9);
    i0.ɵɵelement(10, "geaui-notification-card-v2", 21);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "NOTIFICATIONS-SIDEBAR.DETAILS.TITLE"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("color", "black")("file", "16px_close");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("notification", ctx_r2.detailNotification)("isDetailView", true);
  }
}
export class NotificationsSidebarV2Component {
  notificationsService;
  store;
  _destroyRef;
  closed = new EventEmitter();
  notifications = signal([]);
  unReadNotifications = computed(() => this.filterUnreadNotifications());
  detailNotification = null;
  buttonItems = [{
    id: '1',
    label: 'X.LABEL.NEW'
  }, {
    id: '2',
    label: 'X.LABEL.ALL'
  }];
  showNotificationDetails = false;
  userTimezoneOffset;
  showNewNotifications = true;
  constructor(notificationsService, store, _destroyRef) {
    this.notificationsService = notificationsService;
    this.store = store;
    this._destroyRef = _destroyRef;
    this.store.select(UserState.user).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(user => {
      this.userTimezoneOffset = user?.timeZone?.offset;
    });
  }
  ngOnInit() {
    this.notificationsService.notifications$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(notifications => {
      this.notifications.set(this.applySelectedValues(notifications));
      this.sortNotificationsByCreationDate();
    });
  }
  sortNotificationsByCreationDate() {
    this.notifications().sort((a, b) => b.createdAt.toString().localeCompare(a.createdAt.toString()));
  }
  applySelectedValues(newNotifications) {
    return newNotifications.map(newNotification => {
      const oldNotification = this.notifications().find(old => old.id === newNotification.id);
      return {
        ...newNotification,
        isSelected: oldNotification ? oldNotification.isSelected : false
      };
    });
  }
  onChangeNewAllNotifications(item) {
    this.closeNotificationDetails();
    this.showNewNotifications = item.id === '1';
  }
  readNotification(userNotification) {
    if (userNotification.description.length > 250) {
      this.detailNotification = userNotification;
      this.handleSelection(userNotification);
    } else {
      window.open(userNotification.detailLink, '_self');
    }
    this.notificationsService.markAsRead(userNotification);
  }
  closeNotificationDetails() {
    this.showNotificationDetails = false;
    const selectedNotification = this.notifications().find(notification => notification.isSelected);
    if (selectedNotification) selectedNotification.isSelected = false;
  }
  handleSelection(userNotification) {
    const isDeselecting = userNotification.isSelected;
    if (isDeselecting) this.closeNotificationDetails();else this.showNotificationDetails = true;
    this.notifications.update(notifications => notifications.map(notification => ({
      ...notification,
      isSelected: !isDeselecting && notification.id === userNotification.id
    })));
  }
  filterUnreadNotifications() {
    return this.notifications().filter(n => n.status === 'UNREAD');
  }
  static ɵfac = function NotificationsSidebarV2Component_Factory(t) {
    return new (t || NotificationsSidebarV2Component)(i0.ɵɵdirectiveInject(i1.NotificationsV2Service), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NotificationsSidebarV2Component,
    selectors: [["geaui-notifications-sidebar-v2"]],
    outputs: {
      closed: "closed"
    },
    decls: 19,
    vars: 14,
    consts: [[1, "notification-sidebar-v2-container"], [1, "notification-sidebar-v2-header", "gea-font-heading-20"], ["data-cy", "title"], [1, "notification-sidebar-v2-close-icon", 3, "click"], [3, "color", "file"], [1, "notification-sidebar-v2-border"], [1, "notification-sidebar-content"], [1, "notification-sidebar-content-header"], [3, "activeItemChange", "buttonItems", "activeItem"], ["type", "tertiary", 1, "notification-sidebar-mark-read-button", 3, "click", "preIcon"], [1, "notification-container"], [4, "ngIf"], ["class", "notification-sidebar-notification-detail", 4, "ngIf"], [3, "notification", "userTimezoneOffset"], [3, "notification", "userTimezoneOffset", "markedAsRead", 4, "ngFor", "ngForOf"], [3, "markedAsRead", "notification", "userTimezoneOffset"], [1, "no-notifications-found-container"], [3, "file"], [1, "notifications-found-title", "gea-font-heading-20"], [1, "gea-font-body-14"], [1, "notification-sidebar-notification-detail"], [3, "notification", "isDetailView"]],
    template: function NotificationsSidebarV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0)(1, "header")(2, "div", 1)(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵlistener("click", function NotificationsSidebarV2Component_Template_div_click_6_listener() {
          return ctx.closed.emit();
        });
        i0.ɵɵelement(7, "geaui-icon-v2", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(8, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6)(10, "div", 7)(11, "geaui-button-group-v2", 8);
        i0.ɵɵlistener("activeItemChange", function NotificationsSidebarV2Component_Template_geaui_button_group_v2_activeItemChange_11_listener($event) {
          return ctx.onChangeNewAllNotifications($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "geaui-button-v2", 9);
        i0.ɵɵlistener("click", function NotificationsSidebarV2Component_Template_geaui_button_v2_click_12_listener() {
          return ctx.notificationsService.markAllAsRead();
        });
        i0.ɵɵtext(13);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵtemplate(16, NotificationsSidebarV2Component_ng_container_16_Template, 3, 1, "ng-container", 11)(17, NotificationsSidebarV2Component_ng_container_17_Template, 9, 7, "ng-container", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(18, NotificationsSidebarV2Component_div_18_Template, 11, 7, "div", 12);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 10, "NOTIFICATIONS-SIDEBAR.TITLE"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("color", "black")("file", "16px_close");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("buttonItems", ctx.buttonItems)("activeItem", ctx.buttonItems[0]);
        i0.ɵɵadvance();
        i0.ɵɵproperty("preIcon", "check");
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 12, "NOTIFICATIONS-SIDEBAR.READ-ALL"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.notifications);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.notifications() || ctx.notifications().length < 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.detailNotification && ctx.showNotificationDetails);
      }
    },
    dependencies: [i3.NgForOf, i3.NgIf, i4.IconComponent, i5.ButtonGroupV2Component, i6.ButtonV2Component, i7.NotificationCardV2Component, i8.TranslatePipe],
    styles: [".notification-sidebar-v2-container[_ngcontent-%COMP%]{font-family:GEA Inter,GEA Sans,sans-serif;position:absolute;font-size:16px;width:413px;height:calc(100% - 60px);z-index:10;background:var(--geaui-pure-white);right:0;top:60px;min-height:74px;border:0 none;box-shadow:0 2px 12px #00000014}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-v2-header[_ngcontent-%COMP%]{display:flex;align-items:center;align-self:start;width:100%;position:relative;height:72px}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-v2-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:var(--geaui-pure-black);padding:24px}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-v2-header[_ngcontent-%COMP%]   .notification-sidebar-v2-close-icon[_ngcontent-%COMP%]{position:absolute;right:32px;cursor:pointer}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-v2-border[_ngcontent-%COMP%]{border-bottom:2px solid var(--geaui-grey-05)}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-content[_ngcontent-%COMP%]{overflow-y:auto;height:calc(100% - 75px)}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-content[_ngcontent-%COMP%]   .notification-sidebar-content-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;margin:24px}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-content[_ngcontent-%COMP%]   .notification-sidebar-content-header[_ngcontent-%COMP%]   .notification-sidebar-mark-read-button[_ngcontent-%COMP%]{color:var(--geaui-primary-black)}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-sidebar-notification-detail[_ngcontent-%COMP%]{position:absolute;right:413px;top:0;width:413px;height:100%;background:var(--geaui-pure-white);box-shadow:0 2px 12px #00000014}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-container[_ngcontent-%COMP%]{height:calc(100% - 90px)}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .notification-container[_ngcontent-%COMP%]   .notifications-found-title[_ngcontent-%COMP%]{margin:18px 0}.notification-sidebar-v2-container[_ngcontent-%COMP%]   .no-notifications-found-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%;padding:0 44px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsSidebarV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-notifications-sidebar-v2',
      template: "<section class=\"notification-sidebar-v2-container\">\n  <header>\n    <div class=\"notification-sidebar-v2-header gea-font-heading-20\">\n      <span data-cy=\"title\">{{ 'NOTIFICATIONS-SIDEBAR.TITLE' | translate }}</span>\n      <div class=\"notification-sidebar-v2-close-icon\" (click)=\"closed.emit()\">\n        <geaui-icon-v2 [color]=\"'black'\" [file]=\"'16px_close'\"> </geaui-icon-v2>\n      </div>\n    </div>\n    <div class=\"notification-sidebar-v2-border\"></div>\n  </header>\n  <div class=\"notification-sidebar-content\">\n    <div class=\"notification-sidebar-content-header\">\n      <geaui-button-group-v2\n        [buttonItems]=\"buttonItems\"\n        [activeItem]=\"buttonItems[0]\"\n        (activeItemChange)=\"onChangeNewAllNotifications($event)\">\n      </geaui-button-group-v2>\n      <geaui-button-v2\n        class=\"notification-sidebar-mark-read-button\"\n        [preIcon]=\"'check'\"\n        (click)=\"notificationsService.markAllAsRead()\"\n        type=\"tertiary\">\n        {{ 'NOTIFICATIONS-SIDEBAR.READ-ALL' | translate }}\n      </geaui-button-v2>\n    </div>\n    <div class=\"notification-container\">\n      <ng-container *ngIf=\"notifications\">\n        @if (showNewNotifications) {\n          <geaui-notification-card-v2\n            *ngFor=\"let notification of unReadNotifications()\"\n            [notification]=\"notification\"\n            [userTimezoneOffset]=\"userTimezoneOffset\"\n            (markedAsRead)=\"readNotification(notification)\">\n          </geaui-notification-card-v2>\n        } @else {\n          <geaui-notification-card-v2\n            *ngFor=\"let notification of notifications()\"\n            [notification]=\"notification\"\n            [userTimezoneOffset]=\"userTimezoneOffset\"\n            (markedAsRead)=\"readNotification(notification)\">\n          </geaui-notification-card-v2>\n        }\n      </ng-container>\n      <ng-container *ngIf=\"!notifications() || notifications().length < 1\">\n        <div class=\"no-notifications-found-container\">\n          <geaui-icon-v2 [file]=\"'48px_bell-none'\"></geaui-icon-v2>\n          <div class=\"notifications-found-title gea-font-heading-20\">\n            {{ 'NOTIFICATIONS-SIDEBAR.NO-NOTIFICATIONS-TITLE' | translate }}\n          </div>\n          <div class=\"gea-font-body-14\">{{ 'NOTIFICATIONS-SIDEBAR.NO-NOTIFICATIONS-INFO' | translate }}</div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n  <div class=\"notification-sidebar-notification-detail\" *ngIf=\"detailNotification && showNotificationDetails\">\n    <header>\n      <div class=\"notification-sidebar-v2-header gea-font-heading-20\">\n        <span data-cy=\"title\">{{ 'NOTIFICATIONS-SIDEBAR.DETAILS.TITLE' | translate }}</span>\n        <div class=\"notification-sidebar-v2-close-icon\" (click)=\"closeNotificationDetails()\">\n          <geaui-icon-v2 [color]=\"'black'\" [file]=\"'16px_close'\"> </geaui-icon-v2>\n        </div>\n      </div>\n      <div class=\"notification-sidebar-v2-border\"></div>\n    </header>\n    <ng-container>\n      <geaui-notification-card-v2 [notification]=\"detailNotification\" [isDetailView]=\"true\"></geaui-notification-card-v2>\n    </ng-container>\n  </div>\n</section>\n",
      styles: [".notification-sidebar-v2-container{font-family:GEA Inter,GEA Sans,sans-serif;position:absolute;font-size:16px;width:413px;height:calc(100% - 60px);z-index:10;background:var(--geaui-pure-white);right:0;top:60px;min-height:74px;border:0 none;box-shadow:0 2px 12px #00000014}.notification-sidebar-v2-container .notification-sidebar-v2-header{display:flex;align-items:center;align-self:start;width:100%;position:relative;height:72px}.notification-sidebar-v2-container .notification-sidebar-v2-header span{color:var(--geaui-pure-black);padding:24px}.notification-sidebar-v2-container .notification-sidebar-v2-header .notification-sidebar-v2-close-icon{position:absolute;right:32px;cursor:pointer}.notification-sidebar-v2-container .notification-sidebar-v2-border{border-bottom:2px solid var(--geaui-grey-05)}.notification-sidebar-v2-container .notification-sidebar-content{overflow-y:auto;height:calc(100% - 75px)}.notification-sidebar-v2-container .notification-sidebar-content .notification-sidebar-content-header{display:flex;flex-direction:row;justify-content:space-between;margin:24px}.notification-sidebar-v2-container .notification-sidebar-content .notification-sidebar-content-header .notification-sidebar-mark-read-button{color:var(--geaui-primary-black)}.notification-sidebar-v2-container .notification-sidebar-notification-detail{position:absolute;right:413px;top:0;width:413px;height:100%;background:var(--geaui-pure-white);box-shadow:0 2px 12px #00000014}.notification-sidebar-v2-container .notification-container{height:calc(100% - 90px)}.notification-sidebar-v2-container .notification-container .notifications-found-title{margin:18px 0}.notification-sidebar-v2-container .no-notifications-found-container{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100%;padding:0 44px}\n"]
    }]
  }], () => [{
    type: i1.NotificationsV2Service
  }, {
    type: i2.Store
  }, {
    type: i0.DestroyRef
  }], {
    closed: [{
      type: Output
    }]
  });
})();
